import React, { Component, PropTypes } from 'react';
import './TopUserMenu.scss';
import classNames from 'classnames'

import { Link } from 'react-router';


import { firebaseApp } from '../../../config'

export class TopUserMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleOpen: false
        }
    };

    componentDidMount() {

    }

    _openToggle() {
        this.setState({toggleOpen: !this.state.toggleOpen});
    }

    _signOut() {
      firebaseApp.auth().signOut()
    }

    render() {

        let classes = classNames({
            'toggle': true,
            'open': this.state.toggleOpen
        });
//{this.props.user_facebook.name}

//{ this.props.user_facebook.picture && this.props.user_facebook.picture.data && this.props.user_facebook.picture.data.url && <img src={this.props.user_facebook.picture.data.url} width="100%" />}
        return (
            <div className="top-user-menu">

                <div className={classes} onClick={this._openToggle.bind(this)}>

                    <span className="text">
                        <span className="img">
                          <i className="icon-user"></i>
                        </span>
                    </span>

                    <div className="menu">
                        <ul>
                            <li className='hidden'>
                                <Link className="nav-link" to={"/account/overview"} activeClassName="active">
                                    My Account
                                </Link>
                            </li>
                            <li>
                              <Link className='' to={`/settings`} title='Add' activeClassName='active'>
                                <i className='glyphicon glyphicon-cog' /> &nbsp;Settings
                              </Link>
                            </li>
                            <li className='hidden'>
                                <Link className="nav-link" to={"/account/contact"} activeClassName="active">
                                    Contact us
                                </Link>
                            </li>
                            <li><a onClick={this._signOut.bind(this)}><i className="icon-lock"></i> &nbsp;Sign Out</a></li>
                        </ul>
                    </div>
                </div>


            </div>

        );
    }
}

export default TopUserMenu;



// WEBPACK FOOTER //
// ./src/views/components/TopUserMenu/index.js